import React from "react";
import { useLocation } from "react-router-dom";
import TableTitle from "src/components/home/TableTitle";
import MoreButton from "src/components/button/MoreButton";
import MoreButton2 from "src/components/button/MoreButton2";
import BlogTable from "src/components/table/BlogTable";

interface BlogBoardProps <T = {}> {
  contents: T[];
  isMore: boolean;
  handleLoadMore: () => Promise<void>;
}

const BlogBoard: React.FC<BlogBoardProps> = ({ contents, isMore, handleLoadMore }) => {
  const location = useLocation();
  const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
  
  return (
    <div className={`w-100 py-4 col-12 col-lg ${isMobile?"":"px-3"}`}>
      <TableTitle 
        name="핵심 블로그"
        modalData={{
          title: "핵심 블로그",
          content: [
          "최신: 텔레그램에서 언급된 블로그 최신 글",
          "누적: 텔레그램에서 누적으로 가장 많이 스크랩한 블로그 채널 "
          ]
        }} 
        tabs={["최신", "누적"]}
        type="/blog"
        />
      <BlogTable 
        contents={contents}
      />
      {location.pathname === "/" ?<MoreButton path="/blog" /> : isMore && <MoreButton2 onClick={handleLoadMore} />}
    </div>
  );
};

export default BlogBoard;




